import type { TypeCallToActionWithoutUnresolvableLinksResponse } from '~/types/contentful'

export default function (
  ctas:
    | (TypeCallToActionWithoutUnresolvableLinksResponse | undefined)[]
    | undefined,
  identifier: string,
) {
  return ctas?.find?.((cta) => cta?.fields?.identifier === identifier)
}
